import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/cars/page', data, {
    trim: true
  })
}

// 创建
export function create (data) {
  return request.post('/business/cars/create', data)
}

// 修改
export function updateById (data) {
  return request.post('/business/cars/updateById', data)
}
// 修改
export function sync (data) {
  return request.post('/business/cars/sync', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/business/cars/delete/${id}`)
}

// 批量删除
export function deleteByIdInBatch (ids) {
  return request.get('/business/cars/delete/batch', {
    params: {
      ids
    }
  })
}
